module.exports = __webpack_public_path__ + "img/cbt.91179074.png";